import callAPiBase from './base';

const closeConversationChartApi = {
  list: ({ startDate, endDate, data }: { startDate: number, endDate: number, data: object }) =>
    callAPiBase({
      endpoint: `/api/reports/attendants/conversations?startDate=${startDate}&endDate=${endDate}`,
      method: 'POST',
      useToken: true,
      data,
    }),
};

export { closeConversationChartApi };
export default closeConversationChartApi;
